// Keep in sync with backend/src/config/terms.js.
// Bump when legal content changes — every user will re-accept on next load.
export const CURRENT_TERMS_VERSION = '2026-04-26'
